export const pawelRadziejewski = {
    'mydrId': 'pawełradziejewski',
    'firstName': 'Paweł',
    'lastName': 'Radziejewski',
    'profession': 'Psychiatra dzieci i młodzieży oraz dorosłych',
    'avatar': 'pawel-radziejewski.webp',
    'slug': 'psychiatra-dzieci-i-mlodziezy-pawel-radziejewski',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'children']
    ]
}